import React from 'react'

export const AppHeading = ({ children }) => {
  return (
    <h1 className="text-primary-default text-2xl lg:text-4xl">{children}</h1>
  )
}
